import './NewHowItWorks.css';
const steps = [
  {
    number: '01',
    icon: '📞',
    title: 'Call or Message Us',
    description: 'Tell us your preferred area, budget, and requirements. Our team will understand your needs.',
  },
  {
    number: '02',
    icon: '🔍',
    title: 'We Find Verified Homes',
    description: 'Our field executive visits properties, verifies every detail, and shares only genuine listings with you.',
  },
  {
    number: '03',
    icon: '🏠',
    title: 'Visit & Finalize',
    description: 'Choose from our verified options, visit the property, and finalize your new home with confidence.',
  },
  {
    number: '04',
    icon: '🚚',
    title: 'Move In Stress-Free',
    description: 'We provide free packing cartons, helper support, and trained manpower for a smooth move.',
  },
];
const NewHowItWorks = () => {
  return (
    <section className="how-it-works" id="how-it-works">
      <div className="hiw-container">
        <div className="hiw-header">
          <span className="section-tag">How It Works</span>
          <h2 className="section-title">Your New Home in 4 Simple Steps</h2>
          <p className="section-subtitle">
            From your first call to moving day — we handle everything with care and transparency.
          </p>
        </div>
        <div className="hiw-steps">
          {steps.map((step, index) => (
            <div className="hiw-step" key={index}>
              <div className="hiw-step-number">{step.number}</div>
              <div className="hiw-step-icon">{step.icon}</div>
              <h3 className="hiw-step-title">{step.title}</h3>
              <p className="hiw-step-desc">{step.description}</p>
              {index < steps.length - 1 && <div className="hiw-connector"></div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
export default NewHowItWorks;